import React from 'react';
import { useTimeFormatter } from '../../../../../../data/hooks/datetimeHooks';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import ProgramAtTime from '../../../MeetingDetailsScreen/ProgramAtTime/ProgramAtTime';
import EditIcon from '../../common/EditIcon';
import ClockIcon from './clock-regular-full.svg';
import styles from './CurrentSelectedSlot.module.scss';

function CurrentSelectedSlot(props) {
    const { event, slot, onClick } = props,
        formatTime = useTimeFormatter(),
        i18n = useI18n();

    if (!slot) return null;

    return (
        <>
            <div className={styles.CurrentSelectedSlot} onClick={onClick}>
                <ClockIcon className={styles.clock} />
                <div className={styles.time}>
                    {formatTime(slot.start_local)} - {formatTime(slot.end_local)}
                </div>
                <EditIcon />
            </div>
            <ProgramAtTime className={styles.ProgramAtTime} classNames={{
                programName: styles.programName,
            }} eventId={event.id} start={slot.start_local} end={slot.end_local} title={i18n['label.schedule.at-time']} />
        </>
    );
}

export default CurrentSelectedSlot;
